// Import Tailwind CSS
import './style.css'

// Import existing main.js functionality
import './components/navigation.js'
import { initAnimations } from './components/animations.js'
import './components/forms.js'
import './components/gallery.js'

// Initialize the application
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Gensa İnşaat - Vite ile optimize edildi!')
  
  // Initialize all components
  initializeApp()
})

function initializeApp() {
  // Initialize animations and interactions
  initAnimations()
  
  console.log('✅ Uygulama başlatıldı')
}
